import '@babel/polyfill';
import promise from 'es6-promise';
promise.polyfill();
import Vue from 'vue';
import App from './App.vue';
import router from '@/router';
import { checkLogin } from '@/api/user';
import store from '@/store';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import './style/global.css';
import './assets/icon/iconfont.css';
import './plugins/element';
import 'lib-flexible/flexible.js';
import { storeInfoCrypt, storeInfoDecrypt } from '@/utils/storeInfoCrypt';
import CryptData from './utils/cryptData';
import publicFn from '@/utils/publicFn';
import Video from 'video.js';
import 'video.js/dist/video-js.css';
import Config from './config';
/** 传输数据加密 */
const dataKey = 'gfdV38Wv9pSDysPZ';
let tips_error = function(vm, error) {
  error = JSON.parse(CryptData.decryptByAES(error, dataKey));
  if (error instanceof Object) {
    if (error.code != 402 && error.code != 403) {
      vm.$notify({
        title: '提示',
        message: error instanceof Object ? JSON.stringify(error) : error,
        type: 'error'
      });
    }
  } else {
    if (error.code != 402 && error.code != 403) {
      vm.$notify({
        title: '提示',
        message: error,
        type: 'error'
      });
    }
  }
};

let tips_msg = function(vm, res) {
  if (res.code != 200) {
    vm.$notify({
      title: '提示',
      message: 'error: ' + res.message,
      type: 'error'
    });
  }
};
Vue.prototype.$tips_error = tips_error;
Vue.prototype.$tips_msg = tips_msg;
Vue.config.productionTip = false;
Vue.prototype.$checkLogin = checkLogin;
Vue.prototype.$publicMethods = publicFn;
const BUS = new Vue();
Vue.prototype.$bus = BUS;
Vue.prototype.comImgUrl = Config.imgUrl;
Vue.prototype.$video = Video;

let storeInfo = storeInfoDecrypt(localStorage.getItem('storeInfo'));
let storeObj = storeInfo ? storeInfo : store.state;
if (storeInfo) {
  store.replaceState(Object.assign({}, store.state, storeInfo));
}
store.dispatch('setShowLoginModel', false);

router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
  /* 
  let userObj = storeObj.userInfo ? storeObj.userInfo : {};
  if (!to.meta.authLogin) {
    next();
  } else {
    if (userObj && userObj.userId) {
      //检测是否登录
      let params = {
        id: userObj.userId
      };
      checkLogin(params)
        .then(function(res) {
          if (res.code === 200) {
            if (res.data === "空") {
              NProgress.done();
              next({ path: "/login" });
            } else {
              next();
            }
          }
        }) 
        .catch(function(error) {
          NProgress.done();
          next({ path: "/login" });
        });
    } else {
      NProgress.done();
      next({ path: "/login" });
    }
  } */
});

router.afterEach(() => {
  NProgress.done();
  window.scrollTo(0, 0);
});

//监听页面刷新，保存用户信息
window.addEventListener('beforeunload', () => {
  store.state.isShowLoginModel = false;
  storeInfoCrypt(store.state);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
